import {
  StaffBenefitRequest,
  StaffBenefitCategoryResponse,
  StaffBenefitRequestResponse,
  StaffBenefitResponse,
} from "lib-klab-sdks";
import {
  Benefit,
  BenefitCategory,
  BenefitRequest,
  EmployeeBenefitRequest,
} from "../../../domain/models/employment/benefit.model";

export function mapBenefit(source: any): Benefit {
  return {
    id: source.benefitId || source.id,
    companyId: source.companyId || 1,
    code: source.code || 'B',
    name: source.name,
    description: source.description,
    type: source.type || 'RECREATIONAL',
    validFrom: source.validFrom || source.startDate,
    validUntil: source.validUntil || source.endDate,
    imageUrl: source.imageUrl,
    termsUrl: source.termsUrl || '',
    active: source.active !== undefined ? source.active : true,
    createdByUserId: source.createdByUserId || source.createdBy,
    updatedByUserId: source.updatedByUserId || source.approvedBy,
    createdAt: source.createdAt,
    updatedAt: source.updatedAt,
  };
}

export function mapBenefitRequest(source: BenefitRequest): any {
  const formatDate = (date: any) => {
    if (!date) return null;
    const d = new Date(date);
    return isNaN(d.getTime()) ? null : d.toISOString().split('T')[0];
  };

  return {
    name: source.name,
    description: source.description,
    startDate: formatDate(source.validFrom),
    endDate: formatDate(source.validUntil),
    imageUrl: source.imageUrl,
    address: '',
    maxGuests: 0,
    createdBy: 1,
    rules: [],
    targets: [{ targetType: 'ALL', targetId: null }],
  };
}

export function mapBenefitCategory(source: StaffBenefitCategoryResponse): BenefitCategory {
  return {
    id: source.categoryId,
    code: source.code,
    name: source.name,
    description: source.description,
    sortOrder: source.sortOrder,
    active: source.active,
  };
}

export function mapEmployeeBenefitRequest(
  source: any,
): EmployeeBenefitRequest {
  return {
    id: source.benefitRequestId || source.id,
    benefitId: source.benefitId,
    companyId: source.companyId || 1,
    employeeId: source.employeeId,
    redeemDate: source.redeemDate || source.requestedVisitDate,
    message: source.message || source.employeeComment,
    attachmentUrl: source.attachmentUrl || '',
    status: source.status || (source.statusCode || 'PENDING'),
    decisionMessage: source.decisionMessage || source.adminComment,
    requestedByUserId: source.requestedByUserId || source.employeeId,
    decidedByUserId: source.decidedByUserId || source.reviewedBy,
    decidedAt: source.decidedAt || source.reviewedAt,
    cancelledByUserId: source.cancelledByUserId || null,
    cancelledAt: source.cancelledAt || null,
    createdAt: source.createdAt || source.requestedAt,
    updatedAt: source.updatedAt || source.requestedAt,
  };
}